const initAccordionDesktop = () => {
    const accordionTogglerArray = document.querySelectorAll(".accordion-toggler");
    const accordionChildArray = document.querySelectorAll(".accordion-child");
    if (accordionTogglerArray && accordionTogglerArray.length > 0) {
        accordionTogglerArray.forEach((accordionToggler) => {
            accordionToggler.addEventListener("click", () => {
                accordionToggler.classList.toggle("active");
                accordionChildArray.forEach((accordionChild) => {
                    accordionChild.classList.toggle("active");
                });
            });
        });
    }
};
const initAccordionMobile = () => {
    const accordionTogglerArray = document.querySelectorAll(".accordion-toggler-mobile");
    const accordionChildArray = document.querySelectorAll(".accordion-child-mobile");
    if (accordionTogglerArray && accordionTogglerArray.length > 0) {
        accordionTogglerArray.forEach((accordionToggler) => {
            accordionToggler.addEventListener("click", () => {
                accordionToggler.classList.toggle("active");
                for (const sibling of accordionToggler.parentNode.children) {
                    sibling.classList.toggle('accordion-child-mobile');
                }
            });
        });
    }
};
